import { All, KeyValue } from "../interfaces";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import BranchOfficeMarketSelections from "../components/SOD/BranchOfficeMarketSelections";

export function mapStateToProps({ appState }: All) {
  return {
    appState: (appState as KeyValue)[appState.app],
  };
}
function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateMarketSelection: (values: KeyValue) => {
      dispatch(actions.updateUi("marketSelection", values));
    },
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BranchOfficeMarketSelections);
